module.exports = __webpack_public_path__ + "img/logo_login.b0ef3a80.svg";